import mitt from "mitt";
import type { MemberAddressTypeExtension, Product, VariationTypeExtension } from "@/core/api/graphql/types";
import type { IPage } from "@/shared/thorlabs/shared";
import type { Emitter } from "mitt";
import type { Ref } from "vue";

export type EventType = {
  contentLoaded: IPage;
  tabMounted: { tabId: number };
  infoIconOpened: void;
  tabUpdated: { tabId: number };
  tabChanged: void;
  showSupportDocumentsDialog: { itemId: string };
  showQuickviewLinkDialog: { itemId: string; isDraggable?: boolean | undefined };
  hideQuickviewLinkDialog: { itemIds: string[] };
  /**
   * @deprecated Use useQuickviewRegistry().registerItems() instead
   * This event is kept for backward compatibility but should not be used in new code
   */
  changeQuickviewItemIds: { itemIds: string[] };
  showSupportDocumentsDialog2: { product: Product | VariationTypeExtension };
  showPriceRequestDialog: { product: { code: string } };
  showLeadTimeDialog: { product: Product | VariationTypeExtension };
  showAvailabilityNoteDialog: { product: Product | VariationTypeExtension };
  showVolumePricingDialog: { product: Product | VariationTypeExtension; hideLadderDiscount?: boolean | undefined };
  familyPageTabMounted: { container: Ref<HTMLElement> | undefined };
  familyPageTabUpdated: { container: Ref<HTMLElement> | undefined };
  familyPageTabChanged: { container: Ref<HTMLElement> | undefined };
  familyPageSubgroupMounted: { container: Ref<HTMLElement> | undefined };
  familyPageSubgroupUpdated: { container: Ref<HTMLElement> | undefined };
  familyPageSubgroupChanged: { container: Ref<HTMLElement> | undefined };
  showVideoDialog: { iframeSrc: string };
  hasEnteredShippingAccountNumber: { hasEnteredShippingAccountNumber: boolean };
  hasTaxExemptNumber: { hasTaxExemptNumber: boolean };
  expandCheckoutComponent: { initPaymentForm?: boolean | undefined };
  savedCartLoaded: { cartName: string };
  orderLoaded: { orderNumber: string };
  quoteLoaded: { quoteNumber: string };
  showReorderItemsDialog: { orderId: string };
  placeOrderClicked: void;
  addCardClicked: {
    address: MemberAddressTypeExtension | undefined;
    paymentInstrumentId: string | undefined;
    paymentInstrumentOriginalDataAreaId: string | undefined;
    isDefault: boolean | undefined;
    captchaCode: string;
  };
  updateCardClicked: {
    address: MemberAddressTypeExtension | undefined;
    paymentInstrumentId: string | undefined;
    paymentInstrumentOriginalDataAreaId: string | undefined;
    isDefault: boolean | undefined;
    captchaCode: string;
  };
  closeMenu: void;
  closeSearch: void;
  // search
  updateProductPrice: { pricingItem: Product };
  showCreditCardFormError: { message: string };
  showShippingChoiceFormError: { message: string };
  hideShippingChoiceFormError: void;
  hideCreditCardFormError: void;
  showOrderCreationFailureDialog: { errorMessage?: string };
  showStepUpAuthentication: {
    accessToken: string;
    stepUpUrl: string;
    returnUrl?: string;
    authenticationTransactionId?: string;
  };
  closeStepUpAuthentication: void;
  paymentError: { reason: string };
  // cart
  cartItemAdded: { productCode?: string; quantity: number };
};

export const eventBus: Emitter<EventType> = mitt<EventType>();
